import React, { useState } from "react";
import { Brand } from "../shared/Brand";

export default function Nav({ go }) {
  const [open, setOpen] = useState(false);
  const goClose = (id) => { setOpen(false); go(id); };
  return (
    <nav className="evnav" data-testid="nav">
      <div className="wrap navin">
        <div onClick={() => go("top")} style={{ cursor: "pointer" }} data-testid="nav-logo"><Brand /></div>
        <div className="navlinks">
          <a onClick={() => go("what")} data-testid="nav-what">What We Do</a>
          <a onClick={() => go("results")} data-testid="nav-results">Results</a>
          <a onClick={() => go("sectors")} data-testid="nav-sectors">Sectors</a>
          <a onClick={() => go("faq")} data-testid="nav-faq">FAQ</a>
          <a onClick={() => go("audio")} data-testid="nav-audio">Audio Library</a>
          <a onClick={() => go("solar-installs")} data-testid="nav-installs">Install Services</a>
          <a href="/assets" data-testid="nav-assets">What We Monitor</a>
          <a href="/gap-analysis-pages" data-testid="nav-gap-pages">Gap Analysis Pages</a>
          <a href="/marketing" data-testid="nav-marketing">Marketing</a>
          <a href="/gap-analysis" className="btn" style={{ padding: "10px 20px" }} data-testid="nav-cta">Complimentary Gap Analysis</a>
        </div>
        <button className="navtoggle" onClick={() => setOpen((o) => !o)} aria-label="Menu" aria-expanded={open} data-testid="nav-toggle">
          {open ? (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
          ) : (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" /></svg>
          )}
        </button>
      </div>
      {open && (
        <div className="navmobile" data-testid="nav-mobile">
          <a onClick={() => goClose("what")}>What We Do</a>
          <a onClick={() => goClose("results")}>Results</a>
          <a onClick={() => goClose("sectors")}>Sectors</a>
          <a onClick={() => goClose("faq")}>FAQ</a>
          <a onClick={() => goClose("audio")}>Audio Library</a>
          <a onClick={() => goClose("solar-installs")}>Install Services</a>
          <a href="/assets">What We Monitor</a>
          <a href="/gap-analysis-pages">Gap Analysis Pages</a>
          <a href="/marketing">Marketing</a>
          <a href="/gap-analysis" className="btn" data-testid="nav-mobile-cta">Complimentary Gap Analysis</a>
        </div>
      )}
    </nav>
  );
}
